import * as React from 'react';
import { useEditorContext } from '../editor_context';
import { MenuSeparator } from './MenuSeparator';
import { TextStyleDropdown } from './TextStyleDropdown';

interface TextStyleMenuProps {
   preSeparator?: boolean;
   postSeparator?: boolean;
}

export const TextStyleMenu = (props: TextStyleMenuProps) => {
   const { editor } = useEditorContext();

   if (!editor.schema.nodes.heading) {
      return null;
   }

   return (
      <>
         {props.preSeparator ? <MenuSeparator /> : null}
         <TextStyleDropdown />
         {props.postSeparator ? <MenuSeparator /> : null}
      </>
   );
};
